export const useUpsell = () => {
    const isUpsellAvailable = useState('isUpsellAvailable', () => false);
    const showUpsellModal = useState('showUpsellModal', () => false);

    const registerUpsell = () => {
        isUpsellAvailable.value = true;
    };

    const unregisterUpsell = () => {
        isUpsellAvailable.value = false;
    };

    const triggerUpsell = () => {
        showUpsellModal.value = true;
    };

    const closeUpsell = () => {
        showUpsellModal.value = false;
    };

    return {
        isUpsellAvailable,
        showUpsellModal,
        registerUpsell,
        unregisterUpsell,
        triggerUpsell,
        closeUpsell,
    };
};
